import React from "react";
import CountComponent from "../CountComponent";
import { Box, alpha, useTheme } from "@mui/material";
import pillsImage from "../../assets/images/pills.png";
import glovesImage from "../../assets/images/gloves.png";
import hospitalImage from "../../assets/images/hospital.png";
import bloodImage from "../../assets/images/bloodbag.png";

const Counts = ({ countData, partsLoaded, fetchFunctions, initialQuery, queryOptions = {} }) => {
  const theme = useTheme();
  const iconTileStyle = {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.22 : 0.18),
    display: "flex",
    alignItems: "center",
    padding: "4px",
    borderRadius: "8px",
  };

  const optionalCounts = [
    {
      key: "encounters",
      title: "Encounters",
      option: "encounterCount",
      loadedKey: "encountersCount",
      fetchFunction: fetchFunctions.fetchEncounterData,
      icon: <img src={hospitalImage} height="40" width="40" alt="Hospital" />,
      iconStyle: iconTileStyle,
    },
    {
      key: "medications",
      title: "Medications",
      option: "medicationCount",
      loadedKey: "medicationsCount",
      fetchFunction: fetchFunctions.fetchMedicationData,
      icon: <img src={pillsImage} height="40" width="40" alt="Pills" />,
      iconStyle: iconTileStyle,
    },
    {
      key: "procedures",
      title: "Procedures",
      option: "procedureCount",
      loadedKey: "proceduresCount",
      fetchFunction: fetchFunctions.fetchProcedureData,
      icon: <img src={glovesImage} height="40" width="40" alt="Gloves" />,
      iconStyle: iconTileStyle,
    },
    {
      key: "labs",
      title: "Labs",
      option: "labCount",
      loadedKey: "labsCount",
      fetchFunction: fetchFunctions.fetchLabData,
      icon: <img src={bloodImage} height="40" width="40" alt="Blood" />,
      iconStyle: {
        backgroundColor: "#caedf9",
        display: "flex",
        alignItems: "center",
        padding: "4px",
        borderRadius: "8px",
      },
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
      <CountComponent
        title={"Total Patients"}
        data={countData.patients}
        loading={partsLoaded.patientsCount}
        retryFetchFunction={fetchFunctions.fetchPatientData}
        initialQuery={initialQuery}
        fontWeight={600}
      />
      {optionalCounts
        .filter((count) => queryOptions[count.option])
        .map((count) => (
          <CountComponent
            key={count.key}
            title={count.title}
            data={countData[count.key]}
            loading={partsLoaded[count.loadedKey]}
            retryFetchFunction={count.fetchFunction}
            initialQuery={initialQuery}
            icon={count.icon}
            iconStyle={count.iconStyle}
          />
        ))}
    </Box>
  );
};

export default Counts;
